import { useQuery } from '@tanstack/react-query';

import { getConfigurationSettings } from './configurationSettings';

export const CONFIGURATION_SETTINGS_KEY = 'ConfigurationSettings';

export const useGetConfigurationSettings = () => {
  return useQuery({
    queryKey: [CONFIGURATION_SETTINGS_KEY],
    queryFn: getConfigurationSettings,
  });
};
